import BaseStore from './BaseStore';
import _ from 'lodash';
import rp from 'request-promise';
import config from '../config';
import { getToken } from '../components/Token';
import { getTenantHeaders } from '../components/TenantHeaders';
import { clearLocalStorage } from '../utils/common';
import moment from 'moment';
// import { toJS } from 'mobx';
// import { runInAction } from "mobx";

// const moduleData = []

const defaultUser = [];

export class DashboardStore extends BaseStore {
  constructor() {
    super();
    this.observable({
      loading: false,
      hnList: [],
      // user: _.cloneDeep(defaultUser),
      // modules: _.cloneDeep(moduleData),
      sound: 0,
      dbStatus: {
        id: null,
        status: true,
      },
      routerNoSignal: [],
      lastAction: [],
      dataList: [],
      sort: false,
      userChanged: false,
      fixedEmergencyChanged: false,
    });
    this.hnList = [];
    this.user = _.cloneDeep(defaultUser);
    this.fixedEmergency = [];
  }

  setDataList(datas) {
    // console.log('datas', datas);
    this.dataList = datas;
    this.sort = true;
    // const result = [];
    // datas.forEach(val => {
    //   this.user.filter(item => {
    //     if (item.id === val.id) {
    //       result.push(item);
    //     }
    //     return true;
    //   })
    // })
    // this.user = result;
  }

  setLoading(status) {
    this.loading = status;
  }

  resetDbStatus() {
    this.dbStatus = {
      id: null,
      status: true,
    };
  }

  setAlertDb(alertId) {
    this.dbStatus = {
      id: alertId,
      status: false,
    };
  }

  // setPayloadList(payloadList, task) {
  //     try {
  //     // change format data payload
  //     const payloadListNew = (payloadList || []).map(payload => (task === 'init') ? payload : payload.data);
  //     let beds = _.cloneDeep(this.user);
  //     // const t0 = performance.now()
  //     payloadListNew.forEach(payload => {
  //       const bed = (beds || []).find(b => b.patientId === payload.patientId);
  //       bed && bed.patient && bed.patient.devices && bed.patient.devices.length > 0 && payload.notifications.forEach(notif => {
  //         const tmp = bed.patient.devices.find(d => d.serial === notif.deviceSerial);
  //         if (tmp) {
  //           tmp['action'] = notif;
  //           if (tmp['action'].changed  && typeof(tmp['action'].changed) === 'string') {
  //             tmp['action'].changed = JSON.parse(tmp['action'].changed);
  //           }
  //         }
  //       })

  //       //checking for acknowledge button
  //       const foundAlert = (payload.notifications || []).filter(notif => notif.alertType && (notif.alertCritical === 'true' || notif.alertWarning === 'true'));
  //       if (foundAlert && foundAlert.length > 0) {
  //         bed.alert.acknowledge = true;
  //       } else {
  //         bed.alert && bed.alert.acknowledge && delete bed.alert.acknowledge;
  //       }

  //       // update mute notification for patient
  //       try {
  //         let muteNotification = localStorage.getItem("mute_notification");
  //         muteNotification = muteNotification ? JSON.parse(muteNotification) : [];

  //         const alertIds = (foundAlert || []).map(a => a.alertId);
  //         if (alertIds.length === 0) {
  //           muteNotification = muteNotification.filter(val => val.patientId !== bed.patientId)
  //         } else {
  //           const mutePatient = muteNotification.find(m => m.patientId === bed.patientId);
  //           if (mutePatient) {
  //             const existingAlertIds = (mutePatient.alertId || []).filter(x => alertIds.includes(x));
  //             if (existingAlertIds.length > 0) {
  //               mutePatient.alertId = existingAlertIds;
  //             }
  //             //const newAlertIds = alertIds.filter(x => !(mutePatient.alertId || []).includes(x));
  //             // if (newAlertIds.length > 0) {
  //             //   muteNotification = muteNotification.filter(val => val.patientId !== bed.patientId)
  //             // } else {
  //             //   const existingAlertIds = (mutePatient.alertId || []).filter(x => alertIds.includes(x));
  //             //   if (existingAlertIds.length > 0) {
  //             //     mutePatient.alertId = existingAlertIds;
  //             //   }
  //             // }
  //           }
  //         }
  //         localStorage.setItem("mute_notification", JSON.stringify(muteNotification));
  //       } catch (err) {
  //         console.log('setPayloadList error: ', err);
  //       }
  //       // console.log('setPayloadList bed', bed)
  //     });

  //     // beds.map((bed) => {
  //     //   // check patient have device and status activate on

  //     //   let payloadFilter = bed.patient && bed.patient.devices && toJS(payloadListNew.find(payload => (bed.patient.devices || []).find(device => payload.deviceSerial === device.serial && device.status === 'ACTIVATE_ON')));
  //     //   if (payloadFilter) {
  //     //     if (payloadFilter.alertType && (payloadFilter.alertCritical === 'true' || payloadFilter.alertWarning === 'true')) {
  //     //       if (payloadFilter.alertPriority && payloadFilter.alertPriority !== 0) {
  //     //         bed.alert.alertId = payloadFilter.alertId;
  //     //         bed.alert.signal = payloadFilter.signal === "true" ? true : false;
  //     //         bed.alert.acknowledge = true;
  //     //         bed.alert.alertTime = payloadFilter.alertTime;
  //     //         bed.alert.alertType = payloadFilter.alertType;
  //     //         bed.alert.alertPriority = payloadFilter.alertPriority;
  //     //         bed.alert.alertInfo = payloadFilter.alertInfo;
  //     //         bed.alert.task = (payloadFilter.alertCritical === 'true') ? 'critical' : 'warning';
  //     //       }
  //     //     } else {
  //     //       if (bed.alert.acknowledge) {
  //     //         delete bed.alert.acknowledge;
  //     //       }

  //     //       // if (payloadFilter.changed) {
  //     //         let changed = {};
  //     //         if (payloadFilter.changed) {
  //     //           if (typeof(payloadFilter.changed) === 'string') {
  //     //             changed = payloadFilter.changed ? JSON.parse(payloadFilter.changed) : {};
  //     //           }
  //     //         } else {
  //     //           bed.alert = {}
  //     //         }
  //     //         // const changed = JSON.parse(payloadFilter.changed);
  //     //         if (changed.a || changed.f === 0 || changed.f === 1 || changed.f === 2) {
  //     //           let checkStatusAlert = (bed.patient.devices || []).find((device) => {
  //     //             return (device.serial === payloadFilter.deviceSerial) && (bed.alert.task) && (bed.alert.alertType !== 512) ? true : false
  //     //           })
  //     //           if (checkStatusAlert) {
  //     //             bed.alert = {}
  //     //             if (bed.device && bed.device.action && bed.device.action.alertPriority) {
  //     //               bed.device.action.alertPriority = 0;
  //     //             }
  //     //           }
  //     //           try {
  //     //             let muteNotification = localStorage.getItem("mute_notification");
  //     //             muteNotification = muteNotification ? JSON.parse(muteNotification) : [];
  //     //             muteNotification = muteNotification.filter(val => val.pateintId !== bed.patientId)
  //     //             localStorage.setItem("mute_notification", JSON.stringify(muteNotification));
  //     //           } catch (err) {
  //     //             console.log('setPayloadList error: ', err);
  //     //           }
  //     //         }
  //     //       // }
  //     //     }
  //     //   }
  //     //   return bed;
  //     // })
  //     this.user = beds;
  //     this.userChanged = !this.userChanged;
  //     } catch (err) {
  //       throw err;
  //     }

  // }

  setPayloadList(payloadList, task) {
    // sort by alertPriority and alertTime
    // acknowledge
    // mute Notification
    try {
      // change format data payload
      const payloadListNew = (payloadList || []).map((payload) => (task === 'init' ? payload : payload.data));
      // console.log('payloadListNew', payloadListNew);
      let beds = _.cloneDeep(this.user);
      // const t0 = performance.now()
      payloadListNew.forEach((payload) => {
        const bed = (beds || []).find((b) => b.patientId === payload.patientId);
        bed &&
          bed.patient &&
          bed.patient.devices &&
          bed.patient.devices.length > 0 &&
          payload.notifications.forEach((notif) => {
            const tmp = bed.patient.devices.find((d) => d.serial === notif.deviceSerial);
            if (tmp) {
              tmp['action'] = notif;
              if (tmp['action'].changed && typeof tmp['action'].changed === 'string') {
                tmp['action'].changed = JSON.parse(tmp['action'].changed);
              }
            }
            // console.log('tmp', tmp);
          });

        //checking for acknowledge button
        const foundAlert = payload.patientId
          ? (payload.notifications || []).filter((notif) => {
              const alertWithoutBadSignal = (notif.alerts || []).filter(
                (a) => a.alertType !== 513 && (a.alertCritical === 'true' || a.alertWarning === 'true'),
              );
              return alertWithoutBadSignal.length > 0;
            })
          : null;
        if (bed && foundAlert && foundAlert.length > 0) {
          bed.alert.acknowledge = true;
        } else {
          bed && bed.alert && bed.alert.acknowledge && delete bed.alert.acknowledge;
        }

        // update mute notification for patient
        try {
          let muteNotification = localStorage.getItem('mute_notification');
          muteNotification = muteNotification ? JSON.parse(muteNotification) : [];

          const alertIds = [];
          (foundAlert || []).forEach((f) => {
            f.alerts.forEach((a) => {
              if (a.alertId) {
                alertIds.push(a.alertId);
              }
            });
          });

          if (alertIds.length === 0) {
            if (bed && bed.patientId) {
              muteNotification = muteNotification.filter((val) => bed && val.patientId !== bed.patientId);
            }
          } else {
            const mutePatient = muteNotification.find((m) => bed && m.patientId === bed.patientId);
            if (mutePatient) {
              const existingAlertIds = (mutePatient.alertId || []).filter((x) => alertIds.includes(x));
              if (existingAlertIds.length > 0) {
                mutePatient.alertId = existingAlertIds;
              }
            }
          }
          localStorage.setItem('mute_notification', JSON.stringify(muteNotification));
        } catch (err) {
          console.log('setPayloadList error: ', err);
        }
        // console.log('setPayloadList bed', bed)
      });
      this.user = beds;
      this.userChanged = !this.userChanged;
    } catch (err) {
      throw err;
    }
  }

  resetFixedEmergencyAlarm() {
    this.fixedEmergency = [];
    this.fixedEmergencyChanged = !this.fixedEmergencyChanged;
  }

  setPayloadFixedEmegencyAlarm(payload, payloadType = null) {
    try {
      let fixedEmegencyAlarm = this.fixedEmergency;

      if (payloadType && payloadType === 'acknowledge') {
        (payload.notifications || []).forEach((n) => {
          fixedEmegencyAlarm.map((val) => {
            const notifications = val.notifications.filter((noti) => noti.deviceSerial !== n.deviceSerial);
            val.notifications = notifications;
            return val;
          });
        });
      } else {
        fixedEmegencyAlarm.forEach((val) => {
          const notifications = val.notifications.filter((noti) => noti.deviceSerial !== payload.deviceSerial);
          val.notifications = notifications;
        });

        if (payload.alerts.length > 0) {
          payload.alerts.forEach((a) => {
            const alertDate = moment(new Date(a.alertTime)).format('YYYY-MM-DD');
            const foundDate = (fixedEmegencyAlarm || []).find((e) => e.date === alertDate);
            if (foundDate) {
              fixedEmegencyAlarm.forEach((val) => {
                if (val.date === alertDate) {
                  const noti = [];
                  noti.push(payload);

                  val.notifications = val.notifications.concat(noti);
                }
              });
            } else {
              const data = {
                date: alertDate,
                notifications: [payload],
              };
              fixedEmegencyAlarm.push(data);
            }
          });
        }
      }

      fixedEmegencyAlarm = fixedEmegencyAlarm.filter((e) => e.notifications.length > 0);

      this.fixedEmergency = fixedEmegencyAlarm;
      this.fixedEmergencyChanged = !this.fixedEmergencyChanged;
    } catch (err) {
      throw err;
    }
  }

  reformFixedEmergencyAlarm(data) {
    const fixedAlerts = [];
    const uniqDate = [];

    const uniqDevice = [];
    Object.values(data)
      .flat()
      .forEach((val) => {
        if (!uniqDevice.includes(val.deviceSerial)) {
          uniqDevice.push(val.deviceSerial);
        }
        fixedAlerts.push(val);
      });

    const notifications = uniqDevice.map((deviceSerial) => {
      const lestesAlerts = fixedAlerts
        .filter((alert) => alert.deviceSerial === deviceSerial)
        .sort((a, b) => {
          const alertTimeA = a.alerts[0].alertTime;
          const alertTimeB = b.alerts[0].alertTime;
          if (alertTimeA > alertTimeB) return -1;
          else if (alertTimeA < alertTimeB) return 1;
          return 0;
        });

      if (lestesAlerts[0].alerts.length > 0) {
        const alertDate = moment(new Date(lestesAlerts[0].alerts[0].alertTime)).format('YYYY-MM-DD');
        if (!uniqDate.includes(alertDate)) {
          uniqDate.push(alertDate);
        }
        lestesAlerts[0].date = alertDate;
      }
      return lestesAlerts[0];
    });

    const results = (uniqDate || []).map((date) => {
      const tmp = notifications.filter((n) => n.date === date);
      return { date, notifications: tmp };
    });
    return results;
  }

  validateChange(task, value) {
    if (task === 'a') {
      switch (value) {
        // case 1: case 2: case 3: case 4: case 5: case 6: case 8: case 9: case 10: case 11: case 14: case 15: case 16: case 17: case 18: case 19:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 14:
        case 15:
        case 16:
        case 17:
        case 100:
        case 101:
          return true;
        default:
          return false;
      }
    }
    if (task === 'f') {
      switch (value) {
        case 0:
        case 1:
        case 2:
        case 3:
          return true;
        default:
          return false;
      }
    }
    if (task === 'b') {
      return true;
    }
    if (task === 'm') {
      return true;
    }
  }

  setAlertRouter(routerId, alertId) {
    if (Array.isArray(routerId)) {
      let checkData = (routerId || []).filter((val) => !this.routerNoSignal.find((r) => r.routerId === val));
      if (checkData.length > 0) {
        const formatedData = checkData.map((val) => {
          return { routerId: val, id: alertId };
        });
        this.routerNoSignal = this.routerNoSignal.concat(formatedData);
      }
    } else {
      let checkData = this.routerNoSignal.find((val) => val.routerId === routerId);
      if (!checkData) {
        this.routerNoSignal.push({ routerId: routerId, id: alertId });
      }
    }
  }

  resetAlertRouter(routerId) {
    let routerNoSignal = this.routerNoSignal.filter((val) => val.routerId !== routerId);
    this.routerNoSignal = routerNoSignal;
  }

  async resetRouterNoSignal() {
    this.routerNoSignal = [];
  }

  async updateToken() {
    try {
      this.loading = true;
      const res = await rp
        .post(`${config.api.url_auth}/${config.api.version}/auth/renew`, {
          json: true,
          body: {
            refreshToken: getToken('refresh_token'),
          },
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        //  console.log('refresh_token: ', JSON.stringify(res.body));
        localStorage.setItem('id_token', res.body.IdToken);
      }
      return res;
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getPatientForSubgroup(subGroupId, loading = true) {
    if (subGroupId) {
      this.loading = loading;
      try {
        const data = { subgroups: JSON.parse(subGroupId) };
        const res = await rp
          .post(`${config.api.url}/${config.api.version}/bed/subgroup`, {
            body: data,
            json: true,
            authorization: true,
            resolveWithFullResponse: true,
            headers: {
              ...getTenantHeaders(),
            },
          })
          .auth(null, null, true, getToken('id_token'));
        if (res.statusCode === 200) {
          const hnList = [];
          let bed = res.body || {};
          bed = _.sortBy(bed, ['id']);
          bed = bed.map((data) => {
            data.alert = {};
            data.device = {
              action: {
                changed: {
                  a: null,
                  f: null,
                  b: null,
                  m: null,
                },
              },
            };
            if (data.patient && data.patient.devices) {
              let devices = (data.patient.devices || []).filter((device) => {
                return device.status !== 'DELETED';
              });
              data.patient.devices = devices;
            }
            if (data.patient) {
              data.patient.gender = data.patient.gender ? data.patient.gender.toUpperCase() : data.patient.gender;
              hnList.push({ label: data.patient.hn });
            }
            return data;
          });
          // bed = bed.filter(data => data.patientId === 11506 || data.patientId === 243);
          // runInAction(() => {
          this.hnList = hnList;
          this.user = bed;
          // this.user = bed.reverse().slice(0, 100);

          this.userChanged = !this.userChanged;
          // });
        }
      } catch (err) {
        throw err;
      } finally {
        this.loading = false;
      }
    }
  }

  async getDeviceList(subgroupId, category) {
    this.loading = true;
    let queryOption = {};
    if (subgroupId) {
      queryOption.subgroupId = subgroupId;
    }
    if (category) {
      queryOption.filterCategory = category;
    }
    try {
      let url = `${config.api.url}/${config.api.version}/device?task=web`;
      const res = await rp
        .get(url, {
          qs: queryOption,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const devices = res.body || {};
        return devices;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getLastFixedEmergencyAlarm(subGroupIds) {
    if (subGroupIds.length > 0) {
      this.loading = true;
      try {
        let url = `${config.api.url}/${config.api.version}/notification/fixed/emergency`;
        const res = await rp
          .post(url, {
            authorization: true,
            resolveWithFullResponse: true,
            json: true,
            body: { subGroupIds },
            headers: {
              ...getTenantHeaders(),
            },
          })
          .auth(null, null, true, getToken('id_token'));
        if (res.statusCode === 200) {
          const data = res.body || [];
          this.fixedEmergency = this.reformFixedEmergencyAlarm(data);
          this.fixedEmergencyChanged = !this.fixedEmergencyChanged;
        }
      } catch (err) {
        throw err;
      } finally {
        this.loading = false;
      }
    }
  }

  claertAlertByPatient(patientId) {
    let user = this.user.map((data) => {
      if (data.patient && data.patient.id === patientId) {
        data.alert = {};
      }
      return data;
    });
    this.user = user;
    this.userChanged = !this.userChanged;
  }

  updateDeviceByPatient(patientId, devices) {
    this.claertAlertByPatient(patientId);
    let user = this.user.map((data) => {
      if (data.patient && data.patient.id === patientId) {
        data.patient.devices = devices;
      }
      return data;
    });
    this.user = user;
    this.userChanged = !this.userChanged;
  }

  async assignDevice(devices, patientId) {
    this.loading = true;
    try {
      const detail = {
        devices: devices,
      };
      const res = await rp
        .put(`${config.api.url}/${config.api.version}/device/patient/${patientId}`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));

      if (res && res.statusCode === 200) {
        let index = this.user.findIndex((usr) => usr.patientId === patientId);
        let data = this.user[index];

        if (data.device.id && !devices.find((d) => d.id === data.device.id)) {
          data.alert = {};
          data.device = {
            action: {
              changed: {
                a: null,
                f: null,
                b: null,
                m: null,
              },
            },
          };
          this.user[index] = data;
          this.userChanged = !this.userChanged;
        }

        await rp
          .post(`${config.api.url}/${config.api.version}/fetch`, {
            body: {
              subGroupId: data.subGroupId,
              type: 'deviceUpdate',
              devices: devices,
              patientId: patientId,
            },
            json: true,
            authorization: true,
            resolveWithFullResponse: true,
            headers: {
              ...getTenantHeaders(),
            },
          })
          .auth(null, null, true, getToken('id_token'));
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  clearAlert(bed) {
    const _bed = { ...bed };
    if (_bed.patient && _bed.patient.devices && _bed.patient.devices.length > 0) {
      _bed.alert.acknowledge = true;
      // _bed.patient.devices.forEach(d => {
      //   if (d.action && d.action.alerts.length > 0) {
      //     d.action.alerts.forEach(a => {
      //       a.alertPriority = 0;
      //     });
      //   }
      // });

      let muteNotification = localStorage.getItem('mute_notification');
      muteNotification = muteNotification ? JSON.parse(muteNotification) : [];
      if (muteNotification.find((val) => val.patientId === _bed.patientId)) {
        muteNotification = muteNotification.map((val) => {
          if (val.patientId === _bed.patientId) {
            val.alertId = [];
            if (_bed.patient.devices && _bed.patient.devices.length > 0) {
              _bed.patient.devices.forEach((d) => {
                if (d.action && d.action.alerts.length > 0) {
                  d.action.alerts.forEach((a) => {
                    if (a.alertId && a.alertType !== 513) {
                      val.alertId.push(a.alertId);
                    }
                  });
                }
              });
            }
          }
          return val;
        });
      } else {
        const alertId = [];
        if (_bed.patient.devices && _bed.patient.devices.length > 0) {
          _bed.patient.devices.forEach((d) => {
            if (d.action && d.action.alerts.length > 0) {
              d.action.alerts.forEach((a) => {
                if (a.alertId && a.alertType !== 513) {
                  alertId.push(a.alertId);
                }
              });
            }
          });
        }
        muteNotification.push({ patientId: _bed.patientId, alertId });
      }
      localStorage.setItem('mute_notification', JSON.stringify(muteNotification));

      bed = _bed;
      this.userChanged = !this.userChanged;
    }
  }

  async ackAlert(bed, alerts = null) {
    try {
      if (bed.patient && bed.patient.devices && bed.patient.devices.length > 0) {
        if (localStorage.getItem('user_id') && bed.subGroupId) {
          const detail = {
            subGroupId: bed.subGroupId,
            ackAlerts: [
              {
                patientId: bed.patientId,
                alerts: alerts ? alerts : [],
              },
            ],
          };
          await rp
            .post(`${config.api.url}/${config.api.version}/acknowledge`, {
              body: detail,
              json: true,
              authorization: true,
              resolveWithFullResponse: true,
              headers: {
                ...getTenantHeaders(),
              },
            })
            .auth(null, null, true, getToken('id_token'));
        }
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async ackFixedEmergency(data, alerts = null) {
    try {
      if (localStorage.getItem('user_id')) {
        // const tenantId = +localStorage.getItem('select_tenant');
        const detail = {
          // subGroupId: data.subGroupId,
          // tenantId,
          ackAlerts: [
            {
              deviceSerial: data.deviceSerial,
              alerts: alerts ? alerts : [],
            },
          ],
        };
        await rp
          .post(`${config.api.url}/${config.api.version}/acknowledge`, {
            body: detail,
            json: true,
            authorization: true,
            resolveWithFullResponse: true,
            headers: {
              ...getTenantHeaders(),
            },
          })
          .auth(null, null, true, getToken('id_token'));
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  getAlertID(deviceSerial) {
    let user = this.user.find((data) => {
      if (data.patient && data.patient.devices) {
        return data.patient.devices.find((device) => device.serial === deviceSerial);
      } else {
        return false;
      }
    });
    return user;
  }

  setAlert(alertData, task) {
    let user = this.user.map((data) => {
      if (data.patient) {
        let deviceData = (data.patient.devices || []).find((device) => {
          if (device.serial === alertData.deviceSerial) {
            if (alertData.alertPriority && alertData.alertPriority !== 0) {
              if (device.action && device.action.alertPriority) {
                if (alertData.alertPriority <= device.action.alertPriority) {
                  return true;
                } else {
                  return false;
                }
              } else {
                return true;
              }
            } else {
              return false;
            }
          } else {
            return false;
          }
        });
        if (deviceData) {
          // if (alertData.alertType === 513) {
          //   if (alertData.alertWarning === "true") {
          //     data.alert.signal = true;
          //   } else {
          //     data.alert.signal = false;
          //   }
          // } else {
          data.alert.nosignal = +alertData.nosignal;
          data.alert.alertType = alertData.alertType;
          data.alert.alertInfo = alertData.alertInfo;
          data.alert.task = task;
          data.alert.acknowledge = true;
          // }
        }
      }
      return data;
    });
    this.user = user;
    this.userChanged = !this.userChanged;
  }

  setAction(action) {
    const change = JSON.parse(action.changed);
    let user = this.user.map((data) => {
      if (data.patient) {
        let deviceData = (data.patient.devices || []).find((device) => {
          if (device.serial === action.deviceSerial) {
            change.a = change.a === undefined || change.a === null ? data.device.action.changed.a : change.a;
            change.f = change.f === undefined || change.f === null ? data.device.action.changed.f : change.f;
            change.b = change.b === undefined || change.b === null ? data.device.action.changed.b : change.b;
            change.m = change.m === undefined || change.m === null ? data.device.action.changed.m : change.m;
            action.changed = change;
            // action.alertInfo = (action.alertInfo === undefined || action.alertInfo === null) ? data.device.action.alertInfo : action.alertInfo;
            if (action.alertPriority !== 0 && action.alertPriority) {
              if (device.action && device.action.alertPriority) {
                if (action.alertPriority <= device.action.alertPriority) {
                  device.action = action;
                }
              } else {
                device.action = action;
              }
            } else {
              action.alertPriority =
                !action.alertPriority ||
                action.alertPriority === undefined ||
                action.alertPriority === null ||
                action.alertPriority === 0
                  ? data.device.action.alertPriority
                  : action.alertPriority;
              device.action = action;
            }
            return device;
          } else {
            return false;
          }
        });
        if (deviceData && deviceData.action) {
          data.device = deviceData;
        }
      }
      return data;
    });
    this.user = user;
    this.userChanged = !this.userChanged;
  }

  checkSound() {
    let critical = (this.user || []).filter((data) => {
      return data.alert.task === 'critical';
    });
    let warning = (this.user || []).filter((data) => {
      return data.alert.task === 'warning';
    });
    this.sound = critical.length > 0 ? 2 : warning.length > 0 ? 1 : 0;
  }

  async _lastActivity(data, loading = true) {
    this.loading = loading ? true : false;
    try {
      const detail = {
        serials: data,
      };
      const res = await rp
        .post(
          // `${config.api.url}/api/changelog/lastactivity`,
          `${config.api.url}/${config.api.version}/notification/serial`,
          {
            body: detail,
            json: true,
            authorization: true,
            resolveWithFullResponse: true,
            headers: {
              ...getTenantHeaders(),
            },
          },
        )
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        let lastChange = res.body || [];
        // lastChange = lastChange.filter(val => val.value)
        // lastChange = lastChange.map(val => {
        //   if (val.value) {
        //     val = JSON.parse(val.value);
        //   }
        //   return val;
        // })
        this.lastAction = lastChange;
        return lastChange;
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw new Error(err.error.message);
    } finally {
      this.loading = false;
    }
  }

  async lastActivity(data, loading = true) {
    // this.loading = loading;
    if (config.cache) {
      try {
        const detail = {
          serials: data,
        };
        const res = await rp
          .post(`${config.api.url}/${config.api.version}/notification/serial/cache`, {
            body: detail,
            json: true,
            authorization: true,
            resolveWithFullResponse: true,
            headers: {
              ...getTenantHeaders(),
            },
          })
          .auth(null, null, true, getToken('id_token'));
        let lastChange = res.body || [];
        if (lastChange.length > 0) {
          // lastChange = lastChange.filter(val => val.value)
          // lastChange = lastChange.map(val => {
          //   if (val.value) {
          //     val = JSON.parse(val.value);
          //   }
          //   return val;
          // })
          this.lastAction = lastChange;
          return lastChange;
        } else {
          return await this._lastActivity(data, this.loading);
        }
      } catch (err) {
        if (err.statusCode === 401) {
          clearLocalStorage();
          window.location.href = '/login';
        }
        return await this._lastActivity(data, this.loading);
        // throw new Error(err.error.message);
      } finally {
        // this.loading = false;
      }
    } else {
      return await this._lastActivity(data, this.loading);
    }
  }

  async patientCreate(data, bed) {
    this.loading = true;
    if (data.search) {
      let result = await this.patientAdmit(data, bed, 'search');
      return result.body;
    } else {
      try {
        if (data.patient.dob && data.patient.dob === '0000-00-00') {
          data.patient.dob = null;
        }
        // const detail = data.patient;
        const detail = {
          hn: data.patient.hn,
          tenantId: data.patient.tenantId,
          firstname: data.patient.firstname ? data.patient.firstname : data.patient.firstnameEn,
          lastname: data.patient.lastname ? data.patient.lastname : data.patient.lastnameEn,
          firstnameEn: data.patient.firstnameEn,
          lastnameEn: data.patient.lastnameEn,
          gender: data.patient.gender,
          dob: data.patient.dob,
          age: data.patient.age,
          status: 'ADMITTED',
          weight: data.patient.weight ? parseFloat(data.patient.weight).toFixed(2) : 0,
          height: data.patient.height ? parseFloat(data.patient.height).toFixed(2) : 0,
          contactFirstname: '',
          contactLastname: '',
          contactPhone: '',
        };
        const res = await rp
          .post(`${config.api.url}/${config.api.version}/patient`, {
            body: detail,
            json: true,
            authorization: true,
            resolveWithFullResponse: true,
            headers: {
              ...getTenantHeaders(),
            },
          })
          .auth(null, null, true, getToken('id_token'));
        if (res && res.statusCode === 200) {
          const patient = res.body;
          data.patient = patient;
          let result = await this.patientAdmit(data, bed, 'create');
          return result.body;
        }
      } catch (err) {
        if (err.statusCode === 401) {
          clearLocalStorage();
          window.location.href = '/login';
        }
        // throw new Error(err);
        throw err;
      } finally {
        this.loading = false;
      }
    }
  }

  async patientUpdate(data, bed) {
    this.loading = true;
    try {
      const detail = data.patient;
      detail.weight = detail.weight ? parseFloat(detail.weight).toFixed(2) : 0;
      detail.height = detail.height ? parseFloat(detail.height).toFixed(2) : 0;
      const res = await rp
        .put(`${config.api.url}/${config.api.version}/patient/${data.patient.id}`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        const body = { subGroupId: bed.subGroupId, type: 'patientUpdate' };
        await rp
          .post(`${config.api.url}/${config.api.version}/fetch`, {
            body: body,
            json: true,
            authorization: true,
            resolveWithFullResponse: true,
            headers: {
              ...getTenantHeaders(),
            },
          })
          .auth(null, null, true, getToken('id_token'));
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw new Error(err);
    } finally {
      this.loading = false;
    }
  }

  async patientAdmit(data, bed, task) {
    this.loading = true;
    try {
      const detail = {
        id: task === 'move' ? bed : bed.id,
        patient_id: data.patient.id,
      };
      const res = await rp
        .post(`${config.api.url}/${config.api.version}/bed/admit`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        await rp
          .post(`${config.api.url}/${config.api.version}/fetch`, {
            body: {
              subGroupId: task === 'move' ? data.subGroupId : bed.subGroupId,
              type: 'patientAdmit',
            },
            json: true,
            authorization: true,
            resolveWithFullResponse: true,
            headers: {
              ...getTenantHeaders(),
            },
          })
          .auth(null, null, true, getToken('id_token'));
      }
      return res;
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw new Error(err.error.message);
      //return false;
    } finally {
      this.loading = false;
    }
  }

  async discharge(data, status = true) {
    this.loading = true;
    try {
      const detail = {
        id: data.id,
      };
      const res = await rp
        .post(`${config.api.url}/${config.api.version}/bed/discharge`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (status === true) {
        await rp
          .post(`${config.api.url}/${config.api.version}/fetch`, {
            body: { subGroupId: data.subGroupId, type: 'discharge' },
            json: true,
            authorization: true,
            resolveWithFullResponse: true,
            headers: {
              ...getTenantHeaders(),
            },
          })
          .auth(null, null, true, getToken('id_token'));
      } else {
        let user = this.user.map((data) => {
          if (data.id === res.body.id) {
            data = res.body;
            data.alert = {};
            data.device = {
              action: {
                changed: {
                  a: null,
                  f: null,
                  b: null,
                  m: null,
                },
              },
            };
          }
          return data;
        });
        this.user = user;
        this.userChanged = !this.userChanged;
      }
      return res;
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getBedByPatient(patientId) {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/bed/patient/${patientId}`;
      const res = await rp
        .get(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const bed = res.body || {};
        return bed;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async deleteBedPermanently(bedId) {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/bed/permanent/${bedId}`;
      const res = await rp
        .delete(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        return true;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }
}

export default new DashboardStore();
